import KyeAddress from './address'

export default KyeAddress



// WEBPACK FOOTER //
// ./src/public/components/kye-address/index.js